<script>
import BaseAutocompleteFilter from '@/modules/_global/_components/filters/BaseAutocompleteFilter';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'BuildingComplexesFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    ...mapCacheActions('building', ['getBuildingComplexes']),

    getData() {
      return this.getBuildingComplexes().then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
